import { Link } from 'react-router-dom'

function Footer() {
    return (
        <div className='footer'>
            <div className="footer-top">
                <div className="footer-top-left">
                    <div>
                        <div className='footer-top-left-icon'>
                            <i className="fa-solid fa-location-dot"></i>
                        </div>
                        <div>
                            <p>48 Rue Henriette Lasserre</p>
                            <p>64300, Orthez</p>
                            <p>France</p>
                        </div>
                    </div>
                    <div>
                        <div className='footer-top-left-icon'>
                            <i className="fa-solid fa-phone"></i>
                        </div>
                        <a href="tel:+33695490655">06 95 49 06 55</a>
                    </div>
                    <div>
                        <div className='footer-top-left-icon'>
                            <i className="fa-regular fa-envelope"></i>
                        </div>
                        <a href="mailto:vapephone.boutique@gmail.com">vapephone.boutique@gmail.com</a>
                    </div>
                </div>

                <div className="footer-top-right">
                    <h2>
                        Vape&Phone
                    </h2>

                    <p>Lorem ipsum, dolor sit amet consectetur adipisicing elit. Rem sit sequi dignissimos iste repellat nesciunt. Iusto laborum repellendus voluptatibus eaque sunt. Iusto ut est quam beatae recusandae assumenda delectus voluptatibus!</p>
                    <div className="footer-top-right-social">
                        <div>
                            <a href="https://www.facebook.com/profile.php?id=100091649427261" target="_blank" rel="noreferrer">
                                <i className="fa-brands fa-facebook-f"></i>
                            </a>
                        </div>

                        <div>
                            <a href="https://www.instagram.com/vapephone_orthez/" target="_blank" rel="noreferrer">
                                <i className="fa-brands fa-instagram"></i>
                            </a>
                        </div>
                    </div>
                </div>
            </div>

            <div className="footer-bottom">
                <a href="https://dev-gledic.com/" target="_blank">Copyright ©2023 by <span>Gledic Développement</span></a>

                <div className="footer-bottom-legal">
                    <Link to="/">Mention Légal</Link>
                    <Link to="/">Politique de confidentialité</Link>
                </div>
            </div>
        </div>
    )
}

export default Footer